// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1bzF_","loaderOuter":"PageOverlayLoader_loaderOuter__3sswA"};